(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[40210,65250],{

/***/ 40210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BestTeethAlignersWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
;// CONCATENATED MODULE: ./src/components/bestteethaligners/logo/index.tsx


function BestTeethAlignersLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "333",
        height: "35",
        fill: "none",
        viewBox: "0 0 333 35",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_66)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#262323",
                        d: "M47.194 6.688h19.83v3.444H50.966v8.094h14.806v3.514H50.965v12.51h-3.771V6.688z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M1 21.5l-.5-2 5-.5L5 .5l6 .5 1 18.5h5.5V.5H20v22h2.5l4-14h9V16l3 .5.5 8.5-1.5 6.5-1 1.5-1.5 1.5-3-.5-1.5-3H23l-.5 2-2 1.5-3-1-1-2.5 1-6.5-.5-3H1z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#262323",
                        d: "M69.59 24.106a11.479 11.479 0 012.425-7.777 9.499 9.499 0 0113.447 0 11.467 11.467 0 012.413 7.777c.168 2.807-.69 5.58-2.413 7.802a9.367 9.367 0 01-10.364 2.099 9.368 9.368 0 01-3.072-2.1 11.562 11.562 0 01-2.436-7.8zm3.69 0a9.265 9.265 0 001.44 5.53 4.685 4.685 0 004.018 1.979 4.685 4.685 0 004.018-1.98 9.651 9.651 0 001.406-5.634 8.925 8.925 0 00-1.418-5.388 5.13 5.13 0 00-8.035 0 9.137 9.137 0 00-1.43 5.493zM91.705 14.056h3.514v3.35c1.312-2.577 2.94-3.865 4.908-3.865h.586c.305.02.607.072.902.152v3.713l-1.113-.105a4.802 4.802 0 00-4.31 2.038 4.945 4.945 0 00-.762 1.85 16.254 16.254 0 00-.21 2.988v10.015h-3.515V14.056zM104.239 6.688h3.514v15.58l8.199-8.2h4.604l-7.767 7.45 7.872 12.685h-4.193l-6.021-10.26-2.753 2.588v7.672h-3.514l.059-27.515zM123.121 6.454h3.514v27.75h-3.514V6.453zM131.531 6.688h3.514v3.924h-3.514V6.688zm0 7.368h3.514v20.148h-3.514V14.055zM140.668 34.25V17.125h-3.28v-2.647h3.245v-2.905a5.364 5.364 0 011.112-3.69 4.316 4.316 0 013.362-1.241c.294.005.587.028.879.07l1.558.21v2.976c-.352 0-.645-.106-.891-.129a3.97 3.97 0 00-.574 0 1.9 1.9 0 00-1.628.644 4.485 4.485 0 00-.468 2.46v1.652h3.514v2.647h-3.514V34.25h-3.315zM150.062 14.056h2.647V9.113h3.42v4.943h3.351v2.94h-3.351v12.206c-.07.683.086 1.37.446 1.956a2.334 2.334 0 001.768.527h1.172v2.882h-.563l-2.026.128c-2.085 0-3.385-.761-3.877-2.272a11.915 11.915 0 01-.34-3.514V16.996h-2.647v-2.94zM169.319 6.688h19.843v3.444h-16.025v8.094h14.818v3.514h-14.818v9.055h16.212v3.455h-20.03V6.688zM192.57 27.609h3.678c-.017.581.03 1.162.141 1.733.118.399.341.759.644 1.043a4.934 4.934 0 003.666 1.171 5.552 5.552 0 003.163-.796 2.44 2.44 0 001.171-2.132 1.718 1.718 0 00-.41-1.172 4.228 4.228 0 00-1.557-1.019l-6.349-1.98a5.33 5.33 0 01-3.514-5.153 5.11 5.11 0 012.061-4.229 8.541 8.541 0 015.447-1.628c2.999 0 5.162.957 6.489 2.87.31.466.558.97.738 1.5.154.66.221 1.337.2 2.014h-3.515a2.865 2.865 0 00-.632-2.05 4.594 4.594 0 00-3.397-1.171 4.978 4.978 0 00-2.729.703 2.082 2.082 0 00-1.09 1.757 2.346 2.346 0 001.746 2.342l5.857 1.828 1.405.609c.192.086.376.188.551.304a4.531 4.531 0 012.342 4.077 5.938 5.938 0 01-1.956 4.474 8.598 8.598 0 01-6.079 2.038 8.879 8.879 0 01-6.009-1.815 6.693 6.693 0 01-2.062-5.318zM210.656 14.056h2.647V9.113h3.456v4.943h3.361v2.94h-3.361v12.206c-.071.683.086 1.37.445 1.956a2.343 2.343 0 001.769.527h1.171v2.882h-.574l-2.015.128c-2.097 0-3.397-.761-3.889-2.272a11.915 11.915 0 01-.339-3.514V16.996h-2.648l-.023-2.94zM223.705 6.688h3.514v3.924h-3.514V6.688zm0 7.368h3.514v20.148h-3.514V14.055zM256.866 34.25V21.776a7.564 7.564 0 00-.832-4.206 3.356 3.356 0 00-2.881-1.171 4.887 4.887 0 00-3.831 1.534 6.195 6.195 0 00-1.37 4.288v12.03h-3.456V21.775a7.453 7.453 0 00-.843-4.206 3.338 3.338 0 00-2.87-1.171 4.813 4.813 0 00-3.83 1.605 6.148 6.148 0 00-1.382 4.263V34.25h-3.421V13.986h3.245v2.87a7.026 7.026 0 016.337-3.397 6.35 6.35 0 013.233.773 6.665 6.665 0 012.343 2.413 8.702 8.702 0 012.881-2.413 8.197 8.197 0 013.631-.773 7.67 7.67 0 013.432.714 5.16 5.16 0 012.238 2.062c.302.58.507 1.205.609 1.85a21.35 21.35 0 01.199 3.41V34.25h-3.432zM264.585 20.335a7.543 7.543 0 01.258-2.273c.21-.607.51-1.18.89-1.698 1.359-1.882 3.662-2.823 6.911-2.823 3.28 0 5.529.808 6.723 2.425a6.264 6.264 0 01.984 3.924v9.605c0 1.394.41 2.085 1.23 2.085l.996-.082v2.647a9.941 9.941 0 01-1.171.328 5.866 5.866 0 01-.926.07c-1.886 0-2.952-1.019-3.221-3.045a9.08 9.08 0 01-6.923 3.244 6.781 6.781 0 01-4.685-1.628 5.61 5.61 0 01-1.898-4.404 5.46 5.46 0 013.362-5.365 27.445 27.445 0 017.872-1.663l2.014-.281v-.973a7.766 7.766 0 00-.117-1.476 2.407 2.407 0 00-.457-.937 4.556 4.556 0 00-3.783-1.358 4.322 4.322 0 00-3.842 1.51c-.22.265-.384.572-.48.903a4.895 4.895 0 00-.129 1.241l-3.608.024zm12.369 3.771l-2.471.375c-.761.117-1.687.305-2.788.54a8.261 8.261 0 00-3.28 1.3 2.729 2.729 0 00-.949 2.225 2.809 2.809 0 00.961 2.26 3.97 3.97 0 002.647.809 6.41 6.41 0 004.159-1.382 4.127 4.127 0 001.721-3.303v-2.824zM283.619 14.056h2.648V9.113h3.455v4.943h3.362v2.94h-3.362v12.206c-.07.683.086 1.37.445 1.956a2.339 2.339 0 001.769.527h1.171v2.882h-.574l-2.014.128c-2.097 0-3.397-.761-3.889-2.272a11.915 11.915 0 01-.34-3.514V16.996h-2.647l-.024-2.94zM313.876 25.254h-14.619a6.842 6.842 0 001.476 4.686 5.383 5.383 0 004.158 1.675 4.685 4.685 0 005.072-4.076h3.631a9.25 9.25 0 01-3.08 5.282 8.657 8.657 0 01-5.728 1.898 8.456 8.456 0 01-6.724-2.835 11.495 11.495 0 01-2.46-7.801c0-3.639 1.062-6.372 3.186-8.2a9.139 9.139 0 016.279-2.272 8.361 8.361 0 017.028 3.268 8.887 8.887 0 011.347 2.929c.301 1.27.439 2.572.41 3.877l.024 1.57zm-3.515-3.139a5.322 5.322 0 00-1.464-3.947 5.403 5.403 0 00-3.912-1.441c-3.233 0-5.099 1.812-5.599 5.435l10.975-.047zM316.605 27.609h3.666c-.021.582.03 1.164.152 1.733.108.4.328.762.633 1.043a4.925 4.925 0 003.666 1.171 5.53 5.53 0 003.163-.796 2.444 2.444 0 001.171-2.132 1.73 1.73 0 00-.422-1.172 4.23 4.23 0 00-1.557-1.019l-6.337-1.98a5.33 5.33 0 01-3.514-5.153 5.143 5.143 0 012.061-4.229 8.54 8.54 0 015.517-1.534c2.999 0 5.162.957 6.489 2.87.31.466.558.97.738 1.499.154.66.221 1.337.2 2.015h-3.515a2.865 2.865 0 00-.632-2.05 4.596 4.596 0 00-3.397-1.172 4.978 4.978 0 00-2.729.703 2.083 2.083 0 00-1.09 1.757 2.347 2.347 0 001.746 2.343l5.857 1.827 1.405.61c.192.086.376.188.551.304a4.531 4.531 0 012.342 4.076 5.948 5.948 0 01-1.956 4.475 8.598 8.598 0 01-6.126 2.038 8.879 8.879 0 01-6.009-1.816 6.692 6.692 0 01-2.073-5.411zM20.499 20.112c.632-2.553 1.277-5.107 1.909-7.649a7140.12 7140.12 0 011.523-6.032c.117-.48.27-.598.761-.598H37.46c.55 0 .75.2.75.75v8.785c0 .316.081.398.398.387.597 0 .785.175.785.784v7.58c0 .292 0 .397.363.386.632 0 .808.175.808.785v5.435c0 .573-.188.773-.761.773h-1.347c-.211 0-.27 0-.329.27a4.064 4.064 0 01-7.953 0c0-.235-.129-.306-.375-.306h-5.622c-.188 0-.258 0-.305.247a4.076 4.076 0 01-7.977 0c0-.2-.105-.258-.304-.247h-1.418c-.503 0-.702-.21-.702-.714v-3.35a2.918 2.918 0 012.94-2.94c.55 0 .55 0 .55-.55V22.56c0-.445-.058-.445-.421-.445H.914c-.75 0-.89-.14-.902-.89-.012-.75 0-1.253 0-1.886s.199-.714.703-.714h1.487c.188 0 .234 0 .188-.235a1.792 1.792 0 010-.503v-6.7c-.023-.42.101-.834.351-1.172a.211.211 0 000-.304 1.862 1.862 0 01-.34-1.172V1.792A1.745 1.745 0 014.287-.082h8.48a1.757 1.757 0 011.898 1.91v6.606c.039.45-.086.899-.351 1.265a.199.199 0 000 .28c.244.341.364.754.34 1.172v6.63a1.5 1.5 0 010 .398c-.153.375.058.375.328.375h1.64c.304 0 .386 0 .386-.375V.726c0-.68.164-.843.843-.843h1.816c.68 0 .843.164.843.832v19.397H20.5zm5.283 5.552H16.41a1.756 1.756 0 00-1.804 1.792v1.968c0 .938 0 .926.937.914.21 0 .281-.07.328-.281a4.076 4.076 0 017.977 0c0 .21.105.281.316.281h5.658c.199 0 .27 0 .316-.258a4.076 4.076 0 017.848-.503c.082.246 0 .609.258.714.257.106.515 0 .785 0 .269 0 .35-.117.35-.375v-3.9c0-.328-.081-.41-.397-.41l-13.201.058zm8.925-13.119V9.593c0-.187 0-.269-.246-.269h-7.414c-.2 0-.27.082-.317.258-.68 2.74-1.358 5.47-2.05 8.2-.058.21 0 .292.211.35a1.699 1.699 0 011.382 1.793v1.968c0 .199 0 .269.258.269h5.552c.246 0 .305-.082.293-.305v-4.216a2.051 2.051 0 010-.469 1.757 1.757 0 011.734-1.429c.562 0 .562 0 .562-.574l.035-2.624zm-21.26-7.262v-3.42a.585.585 0 00-.667-.668h-2.226c-.445 0-.328.093-.328.34v3.607a.632.632 0 01-.363.68.656.656 0 01-.75-.223c-.21-.21-.375-.562-.632-.562-.258 0-.434.351-.645.55-.21.2-.433.363-.738.235-.304-.13-.374-.399-.374-.715V1.464c0-.234-.07-.316-.305-.304H4.182c-.457 0-.68.21-.68.69v6.783c0 .48.211.691.691.691h8.551c.492 0 .691-.21.691-.715.012-1.112.012-2.225.012-3.326zm-9.945 9.3v3.432c0 .457.211.668.668.668h8.621a.575.575 0 00.644-.656v-6.852a.573.573 0 00-.644-.656h-2.225c-.446 0-.352.082-.352.351v3.514c0 .316-.058.586-.375.703a.668.668 0 01-.75-.246c-.62-.62-.632-.62-1.24 0-.223.223-.446.387-.774.258-.328-.13-.363-.41-.363-.726V10.8c0-.246 0-.34-.316-.328H4.193c-.445 0-.702.21-.702.714l.011 3.397zm22.256 9.933h8.2c.76 0 .75 0 .773-.761 0-.351-.117-.41-.434-.41H22.982c-.562 0-.797-.304-.656-.843 1.148-4.569 2.292-9.14 3.432-13.717.129-.504.258-.609.785-.609h8.574c.598 0 .773.187.773.797v5.973c0 .82 0 .809.809.82.304 0 .363-.093.363-.374V7.38c0-.27-.059-.375-.363-.375H25.325a.363.363 0 00-.422.328c-1.39 5.56-2.784 11.124-4.182 16.691-.105.469-.105.469.387.469l4.65.023zm-6.501-11.643V1.91c0-.75 0-.726-.761-.75-.328 0-.422.07-.422.41v22.163c0 .761 0 .75.773.773.316 0 .398 0 .398-.387.024-3.76.035-7.508.035-11.268l-.023.023zm18.93 7.872V17.23c0-.27-.083-.328-.329-.317h-1.757c-.199 0-.27 0-.27.258V24.2c0 .211.071.258.27.258h1.757c.246 0 .328 0 .328-.316.012-1.113.023-2.261.023-3.42l-.023.023zm-15.44 10.19a2.917 2.917 0 10-2.928 2.917 2.917 2.917 0 002.952-2.94l-.023.023zm14.268 0a2.915 2.915 0 10-2.929 2.905 2.917 2.917 0 002.952-2.916l-.023.011zM9.933 19.843H1.898c-.75 0-.738 0-.762.761 0 .316.07.41.41.41h14.572c.808 0 .796 0 .808-.82 0-.27-.058-.363-.351-.363-2.18.012-4.405 0-6.618 0l-.024.012zm24.75-.258v-2.413c0-.094 0-.21-.105-.258a.75.75 0 00-1.054.762v3.608c0 .913 0 .901.902.89.21 0 .27-.059.27-.27.011-.773.011-1.546.011-2.33l-.023.011zm-9.604 1.312v-1.02a.597.597 0 00-.54-.62c-.151 0-.245 0-.292.188-.2.831-.41 1.663-.62 2.506 0 .164 0 .234.175.234h1.066c.176 0 .222 0 .222-.222 0-.223.012-.726.012-1.078l-.023.012zM9.055 3.76V1.359c0-.106 0-.2-.141-.188a2.343 2.343 0 00-.96 0c-.176.094 0 .492-.06.75-.058.258 0 .633 0 .949v.89c.493-.351.645-.351 1.16 0zm0 9.37v-1.756c0-.937 0-.937-.95-.879-.151 0-.222 0-.222.2v2.412c.562-.363.656-.363 1.172.024z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FDC611",
                        d: "M25.782 25.664h13.212c.317 0 .41.082.399.41v3.9c0 .259 0 .41-.352.376-.351-.035-.574.07-.785 0-.21-.07-.175-.469-.257-.715a4.075 4.075 0 00-7.848.504c0 .199-.118.258-.317.258h-5.657c-.211 0-.27-.07-.317-.281a4.076 4.076 0 00-7.976 0c0 .21-.118.28-.328.28-.938 0-.938 0-.938-.913v-2.027a1.756 1.756 0 011.804-1.792h9.36zM13.447 5.283v3.362c0 .503-.199.714-.691.714h-8.55c-.481 0-.692-.21-.692-.691V1.862c0-.48.21-.69.68-.69H6.43c.234 0 .316.07.304.304v3.608c0 .316 0 .585.375.714.375.13.527 0 .738-.234.21-.234.375-.562.644-.55.27.011.422.35.633.562a.656.656 0 00.75.222.633.633 0 00.363-.68V1.512c0-.246 0-.351.328-.34.327.012 1.78 0 2.225 0a.586.586 0 01.668.668c-.012 1.101-.012 2.272-.012 3.444zM3.502 14.56v-3.35c0-.504.211-.703.703-.715.492-.011 1.769 0 2.202 0 .258 0 .328.082.317.328v3.573c0 .316 0 .586.363.726s.55 0 .773-.258c.609-.609.62-.609 1.241 0a.668.668 0 00.75.246c.316-.117.375-.386.375-.702v-3.514c0-.27.07-.364.351-.352.281.012 1.78 0 2.226 0a.573.573 0 01.644.656v6.852a.574.574 0 01-.644.656H4.182c-.457 0-.656-.21-.668-.667l-.012-3.48zM25.781 24.493h-4.685c-.492 0-.492 0-.387-.468 1.39-5.56 2.78-11.128 4.17-16.704a.364.364 0 01.422-.328h11.35c.305 0 .364.105.364.375v8.012c0 .281-.059.386-.363.375-.809 0-.809 0-.809-.82V8.96c0-.61-.175-.797-.773-.797h-8.574c-.527 0-.656.106-.785.61-1.148 4.568-2.292 9.14-3.432 13.716-.14.539.094.843.656.843h11.374c.316 0 .445.059.433.41 0 .762 0 .762-.773.762l-8.188-.012z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#262323",
                        d: "M21.611 30.924a1.757 1.757 0 11-3.513-.001 1.757 1.757 0 013.514 0zm-1.733-.598a.586.586 0 10-.046 1.172.586.586 0 00.046-1.172zM34.121 29.167a1.745 1.745 0 11-1.745 1.768 1.768 1.768 0 011.745-1.768zm.586 1.733a.585.585 0 10-1.17.023.585.585 0 001.17-.023z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FDC611",
                        d: "M19.878 30.326a.586.586 0 11-.025 1.172.586.586 0 01.025-1.172zM34.707 30.9a.586.586 0 11-1.172.023.586.586 0 011.172-.023z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_0_66",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H332.746V35H0z"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/bestteethalignersWrapper.tsx








const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function BestTeethAlignersWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Teeth Aligners",
                    domain: "BestTeethAligners.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Teeth Aligners",
                    domain: "BestTeethAligners.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "Best Teeth Aligners Prices",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BestTeethAlignersLogo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ })

}]);